import { DayOfWeek, OpenFromTo } from '@/types-aggregatore';

export const DEFAULT_LOCALE: string = 'it-IT';
const DEFAULT_TIMEZONE: string = 'Europe/Rome';
export const DEFAULT_LOCALE_OPTIONS: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  month: 'short',
  day: '2-digit',
};

export const ONE_DAY_SECONDS = 86400;
export const ONE_DAY_IN_MILLISECONDS = ONE_DAY_SECONDS * 1000;

export const formatDate = ({
  date,
  locale = DEFAULT_LOCALE,
  localeOptions = DEFAULT_LOCALE_OPTIONS,
  timezone = DEFAULT_TIMEZONE,
}: {
  date: Date;
  locale?: string;
  localeOptions?: Intl.DateTimeFormatOptions;
  timezone?: Intl.DateTimeFormatOptions['timeZone'];
}) => {
  return date.toLocaleString(locale, { ...localeOptions, timeZone: timezone });
};

const openhoursConverter = (openhours: OpenFromTo[]) => {
  let str = '';
  for (let i = 0; i < openhours.length; i++) {
    const openhour = openhours[i];
    const isLast = i === openhours.length - 1;
    if (isLast) {
      str += `${openhour.from} / ${openhour.to}`;
      continue;
    }
    str += `${openhour.from} /${openhour.to}` + '-';
  }
  return str;
};

const dayofweekConverter = (dayofweek: DayOfWeek) => {
  switch (dayofweek) {
    case DayOfWeek.Monday:
      return 'LUNEDÌ';
    case DayOfWeek.Tuesday:
      return 'MARTEDÌ';
    case DayOfWeek.Wednesday:
      return 'MERCOLEDÌ';
    case DayOfWeek.Thursday:
      return 'GIOVEDÌ';
    case DayOfWeek.Friday:
      return 'VENERDÌ';
    case DayOfWeek.Saturday:
      return 'SABATO';
    case DayOfWeek.Sunday:
      return 'DOMENICA';
  }
};

export const createOpeningHourObj = (dayofweek: DayOfWeek, openhours: OpenFromTo[]) => ({
  dayofweek: dayofweekConverter(dayofweek),
  openhours: openhoursConverter(openhours),
});
